import React, { useEffect, useState } from "react";
import firebase from "../../../firebase";
import "./blogPost.scss";
import { Button, Card, Modal, Form, Alert } from "react-bootstrap";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import Menu from "@material-ui/icons/PictureAsPdf";
import { NavLink, useHistory,  } from "react-router-dom";

export const SignupForm = (props) => {
const image="https://www.cloudsocial.io/wp-content/uploads/image/guide/CloudSocial%20Guide.webp";
  return (
    <div style={{ marginTop: "10px" }}>
      <Card className="recentCard" style={{padding:"0px",margin:"0px"}}>
        <Card className="recentBlogCard"  style={{padding:"0px",margin:"0px"}}>
          <Card.Body style={{ padding: "0px" }}>
            <Card.Img variant="top" src={image} alt="guide" />
           
            <Card.Footer className="mb-3 mt-3" style={{textAlign:"center"}}>
               <NavLink
                className="recentBlogNavLink"
                to={`/ebook`}
              >
                <Button
                  size="small"
                  style={{backgroundColor:"#6d6ef3"}}
                >
                   Explore Free Guides &nbsp;
                  <Menu />
                </Button>
              </NavLink>
                {/* <Button
              onClick={handleShow}
              target="_blank"
              size="small"
              color="primary"
            >
              Explore Free Guides
              &nbsp;
              <Menu />
            </Button> */}
            </Card.Footer>
          </Card.Body>
        </Card>
    
      </Card>
    </div>
  );
};
